// src/components/SideMenu/SideMuenu.js
import React from 'react'

import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav'
import '@trendmicro/react-sidenav/dist/react-sidenav.css'
import MenuSeparator from './MenuSeparator'

import { removeItem } from 'utils/localstorage'
import { LOCALSTORAGE_KEY } from 'config/general'
import { ENVIO_POR_BULTOS_HABILITADO } from 'config/envio'
import { FINANCIACION_HABILITADA } from 'config/financiacion'
import { HABILITAR_ATRIBUTOS } from 'config/productos'
import { FAQ_HABILITADA, TYC_HABILITADA, PUBLICACIONES_HABILITADAS } from 'config/general'
import Logo from 'assets/logo.png'
import './SideMenu.css'

function SideMenu(props) {
	const { location, history, setLoggedIn, menuExpanded, setMenuExpanded } = props

	const onToggle = (isExpanded) => {
		setMenuExpanded(isExpanded)
	}

	const handleLogOut = () => {
		setLoggedIn(false)
		removeItem(LOCALSTORAGE_KEY)
	}

	let selected = location.pathname.substring(1)
	if (selected === 'login' || selected === '') {
		selected = 'inicio'
	}

	return (
		<SideNav expanded={menuExpanded} onToggle={onToggle} id="sidenav"
			onSelect={(selected) => {
				const to = '/' + selected
				if (location.pathname !== to) {
					history.push(to)
				}
			}}
		>
			<SideNav.Toggle />
			<div className="sidenavHeader">

			</div>
			<SideNav.Nav defaultSelected={selected}>
				<div className="sidenavLogo">
					<img src={Logo} alt="logo" />
				</div>
				<NavItem eventKey="inicio">
					<NavIcon>
						<i className="fa-solid fa-gauge-high" />
					</NavIcon>
					<NavText>
						Inicio
					</NavText>
				</NavItem>
				<NavItem eventKey="usuarios/administradores">
					<NavIcon>
						<i className="fa-solid fa-users-gear" />
					</NavIcon>
					<NavText>
						Administradores
					</NavText>
				</NavItem>
				{HABILITAR_ATRIBUTOS && (
					<NavItem eventKey="atributos">
						<NavIcon>
							<i className="fa fa-sliders" />
						</NavIcon>
						<NavText>
							Atributos
						</NavText>
					</NavItem>
				)}
				<NavItem eventKey="categorias">
					<NavIcon>
						<i className="fa-solid fa-tags" />
					</NavIcon>
					<NavText>
						Categorías
					</NavText>
				</NavItem>
				<NavItem eventKey="productos">
					<NavIcon>
						<i className="fa-solid fa-boxes" />
					</NavIcon>
					<NavText>
						Productos
					</NavText>
				</NavItem>
				<NavItem eventKey="usuarios/clientes">
					<NavIcon>
						<i className="fa-solid fa-users" />
					</NavIcon>
					<NavText>
						Clientes
					</NavText>
				</NavItem>
				<NavItem eventKey="pedidos">
					<NavIcon>
						<i className="fa fa-list-check" />
					</NavIcon>
					<NavText>
						Pedidos <div className="submenu-nav"><i className="fa fa-caret-down expand"></i> <i className="fa fa-caret-up collapse"></i></div>
					</NavText>
					<NavItem eventKey="pedidos">
						<NavIcon>
							<i className="fa fa-list-check" style={{ fontSize: 16 }} />
						</NavIcon>
						<NavText title="Actuales">
							Actuales
						</NavText>
					</NavItem>
					<NavItem eventKey="pedidos-historial">
						<NavIcon>
							<i className="fa fa-history" style={{ fontSize: 16 }} />
						</NavIcon>
						<NavText title="Historial">
							Historial
						</NavText>
					</NavItem>
				</NavItem>
				<NavItem eventKey="reportes">
					<NavIcon>
						<i className="fa fa-chart-pie" />
					</NavIcon>
					<NavText>
						Reportes <div className="submenu-nav"><i className="fa fa-caret-down expand"></i> <i className="fa fa-caret-up collapse"></i></div>
					</NavText>
					<NavItem eventKey="reportes/ventas">
						<NavIcon>
							<i className="fa fa-chart-line" style={{ fontSize: 16 }} />
						</NavIcon>
						<NavText title="Ventas por rango">
							Ventas por rango
						</NavText>
					</NavItem>
					<NavItem eventKey="reportes/productos">
						<NavIcon>
							<i className="fa fa-box" style={{ fontSize: 16 }} />
						</NavIcon>
						<NavText title="Productos más vendidos">
							Productos más vendidos
						</NavText>
					</NavItem>
					<NavItem eventKey="reportes/categorias">
						<NavIcon>
							<i className="fa fa-tags" style={{ fontSize: 16 }} />
						</NavIcon>
						<NavText title="Categorías más vendidas">
							Categorías más vendidas
						</NavText>
					</NavItem>
				</NavItem>
				<NavItem eventKey="modificaciones">
					<NavIcon>
						<i className="fa fa-window-restore" />
					</NavIcon>
					<NavText>
						Contenido web <div className="submenu-nav"><i className="fa fa-caret-down expand"></i> <i className="fa fa-caret-up collapse"></i></div>
					</NavText>
					<NavItem eventKey="modificaciones/inicio">
						<NavText title="Inicio">
							Inicio
						</NavText>
					</NavItem>
					<NavItem eventKey="modificaciones/acerca-de">
						<NavText title="Acerca de">
							Acerca de
						</NavText>
					</NavItem>
					<NavItem eventKey="modificaciones/contacto">
						<NavText title="Contacto">
							Contacto
						</NavText>
					</NavItem>
				</NavItem>
				{PUBLICACIONES_HABILITADAS && (
					<NavItem eventKey="publicaciones">
						<NavIcon>
							<i className="fa fa-newspaper" />
						</NavIcon>
						<NavText>
							Publicaciones
						</NavText>
					</NavItem>
				)}
				<NavItem eventKey="info-destacada">
					<NavIcon>
						<i className="fa fa-star" />
					</NavIcon>
					<NavText>
						Info Destacada
					</NavText>
				</NavItem>
				{FAQ_HABILITADA && (
					<NavItem eventKey="faq">
						<NavIcon>
							<i className="fa fa-question-circle" />
						</NavIcon>
						<NavText>
							Preguntas Frecuentes
						</NavText>
					</NavItem>
				)}
				{TYC_HABILITADA && (
					<NavItem eventKey="terminos">
						<NavIcon>
							<i className="fa fa-scale-balanced" />
						</NavIcon>
						<NavText>
							Términos y Condiciones
						</NavText>
					</NavItem>
				)}
				<NavItem eventKey="cuentas-bancarias">
					<NavIcon>
						<i className="fa fa-building-columns" />
					</NavIcon>
					<NavText>
						Cuentas Bancarias
					</NavText>
				</NavItem>
				{ENVIO_POR_BULTOS_HABILITADO && (
					<NavItem eventKey="envio-bultos">
						<NavIcon>
							<i className="fa fa-box" />
						</NavIcon>
						<NavText>
							Envío por Bultos
						</NavText>
					</NavItem>
				)}
				{FINANCIACION_HABILITADA && (
					<NavItem eventKey="financiacion">
						<NavIcon>
							<i className="fa fa-credit-card" />
						</NavIcon>
						<NavText>
							Financiación
						</NavText>
					</NavItem>
				)}
				<MenuSeparator />
				<NavItem eventKey="logout" onClick={handleLogOut}>
					<NavIcon>
						<i className="fa fa-fw fa-power-off" style={{ fontSize: '1.5em' }} />
					</NavIcon>
					<NavText style={{ paddingRight: 32 }} title="Cerrar">
						Cerrar
					</NavText>
				</NavItem>
			</SideNav.Nav>
		</SideNav>
	)
}

export default SideMenu